import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// Handles the Google OAuth return: exchanges session_id for a session cookie.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setCtx } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const run = async () => {
      if (!match) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/api/auth/google/session", {
          session_id: decodeURIComponent(match[1]),
        });
        setCtx(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.onboarded ? "/" : "/onboarding", { replace: true });
      } catch {
        navigate("/login?error=google", { replace: true });
      }
    };
    run();
  }, [navigate, setCtx]);

  return (
    <div className="flex h-screen items-center justify-center bg-background" data-testid="auth-callback">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  );
}
